import styled from "styled-components";
import { useTranslation, useCustomImage } from "../../../hooks";

const getFontSize = (text: string): string => {
  const baseWidth = 12;
  const step = 0.25;
  // this is complate
  const minSize = text.length < 20 ? 0.6 : 0.5;

  if (text.length <= baseWidth) return "";

  const width = Math.max(1 - (text.length - baseWidth) * step, minSize);

  return width.toFixed(2) + "em";
};

const StyledHeader = styled.div`
  font-size: 1.6em;
  display: flex;
  justify-content: center;
  align-items: center;

  .header-background {
    background-image: url(${(props: any) => props.background});
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    text-align: center;
    height: 2.9em;
    min-width: 15em;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    .header-title {
      line-height: 1em;
      font-size: ${(props: any) => getFontSize(props.title)};
    }
  }
  ${(props: any) => props.customStyle || ""}
` as any;

const Header: React.FC<{ title: string; customStyle: string }> = ({
  title,
  customStyle,
}) => {
  const translatedTitle = useTranslation(title);

  return (
    <StyledHeader
      background={useCustomImage("paytable/header.webp")}
      title={translatedTitle}
      customStyle={customStyle}
    >
      <div className="header-background">
        <div className="header-title">{translatedTitle}</div>
      </div>
    </StyledHeader>
  );
};

export default Header;
